// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PGlo","right":"styles_right__3ug3Q"};